import DropShadowPostFxPipeline from './shaders/dropshadow/DropShadowPostFxPipeline.js';
export default DropShadowPostFxPipeline;